var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment Method/Visa"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BASE",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.536 16.2582H9.23396L7.50769 10.1924C7.42576 9.91334 7.25178 9.66667 6.99587 9.5504C6.35722 9.25823 5.65347 9.0257 4.88574 8.90843V8.6749H8.59419C9.106 8.6749 9.48987 9.0257 9.55385 9.43313L10.4495 13.8086L12.7505 8.6749H14.9886L11.536 16.2582ZM16.2681 16.2582H14.094L15.8842 8.6749H18.0584L16.2681 16.2582ZM20.8711 10.7757C20.9351 10.3673 21.319 10.1337 21.7668 10.1337C22.4705 10.0751 23.2372 10.1924 23.8769 10.4835L24.2608 8.85081C23.621 8.61727 22.9173 8.5 22.2786 8.5C20.1685 8.5 18.633 9.55041 18.633 11.0082C18.633 12.1173 19.7206 12.6996 20.4884 13.0504C21.319 13.4002 21.6388 13.6338 21.5749 13.9835C21.5749 14.5082 20.9351 14.7418 20.2964 14.7418C19.5287 14.7418 18.761 14.5669 18.0584 14.2747L17.6745 15.9085C18.4422 16.1996 19.2728 16.3169 20.0405 16.3169C22.4066 16.3745 23.8769 15.3251 23.8769 13.75C23.8769 11.7665 20.8711 11.6502 20.8711 10.7757ZM31.4857 16.2582L29.7595 8.6749H27.9053C27.5214 8.6749 27.1375 8.90843 27.0096 9.25823L23.8129 16.2582H26.051L26.4978 15.1502H29.2477L29.5036 16.2582H31.4857ZM28.2251 10.7171L28.8638 13.5751H27.0735L28.2251 10.7171Z",
    fill: "#172B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.94bdf648e70d1993dbd805e072c1c06f.svg";
export { ForwardRef as ReactComponent };